import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    quizRowContainer: {
        overflowX: 'scroll',
        height: '90%',
        width: '100%',
        display: 'flex',
        paddingRight: '16px',
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    quizRow: {
        width: '100%',
        margin: 0,
        display: 'grid',
        gap: 1,
        height: `100%`,
        alignContent: 'center',
    },
    colorItem: {
        width: '100%',
        height: '100%',
        // minHeight: 90,
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        padding: '60px 0 12px 0',
    },
    buttonContinue: {
        color: 'white',
        textDecoration: 'none',
        textTransform: 'none',
    },
    wrapperItem: {},
    boxItem: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 8,
        padding: 10,
        width: '175px',
        height: '100%',
    },
    itemTitle: {
        fontWeight: 'bold',
        fontFamily: 'PoppinsSemiBold',
        margin: 0,
        padding: 0,
        fontSize: 14,
    },
}));
